import ReCAPTCHA from "react-google-recaptcha"
import { useRef, useState, useEffect } from "react"
import { fetchEventSignupData } from "@/lib/api/events"
import Blocks from "@/components/Blocks"

export default function CalendarSingle({ block }) {
  const { eventId } = block.attrs
  const [signupDataLoading, setSignupDataLoading] = useState(false)
  const [signupData, setSignupData] = useState({})

  const siteKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY
  const recaptchaRef = useRef()

  const getSignupData = async (eventId) => {
    setSignupDataLoading(true)
    const captcha = await recaptchaRef.current.executeAsync()
    fetchEventSignupData(eventId, captcha).then((response) => {
      setSignupDataLoading(false)
      setSignupData(response)
    })
  }

  useEffect(() => {
    getSignupData(eventId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const blockData = {
    loading: signupDataLoading,
    ...signupData,
    getSignupData
  }
  const settings = {
    "theme/event-main": blockData,
    "theme/event-info": blockData,
    "theme/event-form": blockData
  }

  return (
    <>
      <ReCAPTCHA
        className="hidden"
        ref={recaptchaRef}
        size="invisible"
        sitekey={siteKey}
      />
      <Blocks blocks={block.innerBlocks} settings={settings} />
    </>
  )
}
